import classNames from "classnames";
import { MotorVehicleSearchProductItem } from "Hooks/Api/apiPrice";
import { useContext } from "react";
import { Button, Display, Widths } from "../Button/Button";
import { MotorVehicleDispatchContext, MotorVehicleSearchContext } from "./MotorVehicleSearchReducers";
import { MvsModal } from "./MvsModalComponents";

type MotorVehicleSearchProductCardProps = {
	// The id of the current selected product
	selectedId?: string;
	data: MotorVehicleSearchProductItem;
	onClick: (model: MotorVehicleSearchProductItem) => void;
}
export function MotorVehicleSearchProductCard(props: MotorVehicleSearchProductCardProps) {
	const {
		selectedId,
		data,
		onClick
	} = props;

	const {
		id,
		name,
		price,
		productDescription,
		isPopular
	} = data;

	const isSelected = selectedId === data.id;

	const selectText = isSelected ? "Selected" : "Select Report";
	const clzNames = classNames("mvs-product-card", isSelected ? "mvs-product-card__selected" : "");

	return (
		<div className={clzNames} onClick={() => onClick(data)}>
			<div className="popular">
				{isPopular && (<span>Most Popular</span>)}
			</div>

			<p className="title txt-lg-body txt-bold">{name}</p>

			<div className="price">
				<span className="txt-xlg-body">${price.toFixed(2)}</span>
				<span className="txt-body persearch">/per search</span>
			</div>
			<hr className="grey-line" />
			{productDescription.map(desc => (
				<ServiceFeatureDescription key={`${id}-${desc}`} id={`${id}-${desc}`} description={desc} />
			))}

			<div className="btn-container">
				<Button widths={Widths.fullWidth} display={isSelected ? Display.Solid : Display.Outline}>{selectText}</Button>
			</div>
		</div>
	)
}

type ServiceFeatureDescriptionProps = { id: string, description: string }
function ServiceFeatureDescription(props: ServiceFeatureDescriptionProps) {
	const {
		id,
		description
	} = props;

	return (
		<div key={`${id}`} className="feature-description-row">
			<span className="icon icon-check-circle-3 icon-left" />
			<p className="txt-body">{description}</p>
		</div>
	)
}

export function MotorVehicleSearchProductSelector(props: {
	productOptions: MotorVehicleSearchProductItem[]
}) {
	const { productOptions } = props;

	const {
		data: {
			product
		}
	} = useContext(MotorVehicleSearchContext);
	const dispatch = useContext(MotorVehicleDispatchContext);

	const handleOnClickCard = (model: MotorVehicleSearchProductItem) => {
		dispatch({ type: "SetServicePrice", payload: {
			servicePrice: model
		}});
	}

	return (
		<>
			<MvsModal.SectionTitle name="Select a report type" />

			<div className="mvs-products">
				{/* Order lowest product first */}
				{productOptions.sort((a, b) => a.price - b.price).map(item => (
					<MotorVehicleSearchProductCard
						key={item.id}
						selectedId={product?.id}
						data={item}
						onClick={handleOnClickCard} />
				))}
			</div>
		</>
	);
}
